export function buildApiUrl(apiBase, path) {
  const normalizedPath = path.replace(/^\/+/, '')
  const backendPath = new URL(normalizedPath, apiBase).pathname

  if (process.env.NODE_ENV === 'development') {
    return `/api${backendPath}`
  }

  return backendPath
}
